<div class="modal-header">
    <h5 class="modal-title d-inline-flex align-items-center">
        <i *ngIf="view === 'edit'" class="bi bi-arrow-left clickable me-2" (click)="cancelEdit()"
            title="Back to contacts"></i>
        <ng-container *ngIf="view === 'list'">{{ client?.name }} contacts</ng-container>
        <ng-container *ngIf="view === 'edit' && editing">
            Edit contact · {{ editing.first_name }} {{ editing.last_name }}
        </ng-container>
    </h5>
    <mat-icon class="close clickable me-4" (click)="onClose()">close</mat-icon>
</div>

<!-- ============================================================
     LIST VIEW
     ============================================================ -->
<div class="modal-body cl-list-body" *ngIf="view === 'list'" #listScroller>

    <div class="contacts-list-head">
        <div class="client-logo">{{ authService.getInitials(client?.name || '') | uppercase }}</div>
        <div class="text">
            <div class="eyebrow">Client</div>
            <h2 class="cl-title">{{ client?.name }}</h2>
            <div class="meta">
                <span>{{ activeContacts.length }} contact<span *ngIf="activeContacts.length !== 1">s</span></span>
                <span class="dot">·</span>
                <span>Active</span>
            </div>
        </div>
        <button type="button" class="ec-btn ec-btn-primary add-contact" (click)="openAddView()"
            *ngIf="clientContacts.length > 0">
            <i class="bi bi-plus-lg"></i>Add contact
        </button>
    </div>

    <div class="contacts-list-stack">
        <div class="cl-loader" *ngIf="loading">
            <mat-spinner diameter="36"></mat-spinner>
        </div>

        <ng-container *ngIf="!loading && clientContacts.length === 0">
            <div class="cl-empty">
                <div class="cl-empty-ico"><i class="bi bi-person-lines-fill"></i></div>
                <div class="cl-empty-title">No contacts yet</div>
                <div class="cl-empty-sub">Add a contact to start sending approval emails.</div>
                <button type="button" class="ec-btn ec-btn-primary" (click)="openAddView()">
                    <i class="bi bi-plus-lg"></i>Add the first contact
                </button>
            </div>
        </ng-container>

        <ng-container *ngIf="!loading && clientContacts.length > 0">
            <div class="contact-row" *ngFor="let contact of clientContacts; trackBy: trackByContact"
                (click)="rowClick(contact, $event)" role="button" tabindex="0">
                <div class="avatar"
                    *ngIf="!contact.profile_pic">{{ authService.getInitials(contact.name || ((contact.first_name || '') + ' ' + (contact.last_name || ''))) | uppercase }}</div>
                <div class="avatar avatar-img" *ngIf="contact.profile_pic">
                    <img alt="" [src]="dataSharedService.getImage(contact.profile_pic)" />
                </div>

                <div class="who">
                    <div class="name">
                        <span>{{ contact.name || ((contact.first_name || '') + ' ' + (contact.last_name || '')) }}</span>
                        <span class="invite-chip" *ngIf="contact.send_invite">
                            <i class="bi bi-envelope-check"></i>Invite
                        </span>
                    </div>
                    <div class="email">{{ contact.email }}</div>
                    <div class="style-line" *ngIf="contact.timesheet_notification_settings?.email_type === 1">
                        <i class="bi bi-collection"></i>
                        <strong>Bulk digest</strong>
                        <span>· {{ dayName(contact.timesheet_notification_settings?.day) }}
                            {{ contact.timesheet_notification_settings?.time }}</span>
                    </div>
                    <div class="style-line" *ngIf="contact.timesheet_notification_settings?.email_type !== 1">
                        <i class="bi bi-envelope"></i>
                        <strong>Individual approval</strong>
                    </div>
                </div>

                <span class="status-tag" [class.active]="isContactActive(contact)"
                    [class.inactive]="!isContactActive(contact)">
                    <i class="bi"
                        [class.bi-check-circle-fill]="isContactActive(contact)"
                        [class.bi-dash-circle-fill]="!isContactActive(contact)"></i>
                    {{ isContactActive(contact) ? 'Active' : 'Inactive' }}
                </span>

                <div class="actions">
                    <button type="button" class="icon-btn-sm row-action" title="Resend invite"
                        (click)="$event.stopPropagation(); resendAccountActivation(contact.uuid)">
                        <i class="bi bi-send"></i>
                    </button>
                    <button type="button" class="icon-btn-sm row-action" title="Edit contact"
                        (click)="$event.stopPropagation(); openEditView(contact)">
                        <i class="bi bi-pencil"></i>
                    </button>
                    <button type="button" class="icon-btn-sm row-action danger"
                        *ngIf="isContactActive(contact)"
                        title="Deactivate contact"
                        (click)="$event.stopPropagation(); deactivateClientContact(client, contact)">
                        <i class="bi bi-person-x"></i>
                    </button>
                    <button type="button" class="icon-btn-sm row-action"
                        *ngIf="!isContactActive(contact)"
                        title="Activate contact"
                        (click)="$event.stopPropagation(); activateClientContact(client, contact)">
                        <i class="bi bi-person-plus"></i>
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<!-- ============================================================
     EDIT VIEW (inline — no second modal)
     ============================================================ -->
<ng-container *ngIf="view === 'edit' && editing">
    <div class="ec-hero">
        <div class="avatar-lg">{{ contactInitials(editing) }}</div>
        <div class="text">
            <div class="eyebrow">Edit contact</div>
            <h2>{{ editing.first_name }} {{ editing.last_name }}</h2>
            <div class="sub">Approver at <strong>{{ client?.name }}</strong></div>
        </div>
        <span class="status-pill" [class.inactive]="!editing.active">
            <i class="bi" [class.bi-check-circle-fill]="editing.active" [class.bi-dash-circle-fill]="!editing.active"></i>
            {{ editing.active ? 'Active' : 'Inactive' }}
        </span>
    </div>

    <div class="ec-form">
        <div class="grid-2">
            <div class="field">
                <label>First name <span class="req">*</span></label>
                <input type="text" class="input-form" [class.ec-invalid]="isInvalid('first_name')"
                    [(ngModel)]="editing.first_name" [ngModelOptions]="{standalone: true}" placeholder="First name" />
            </div>
            <div class="field">
                <label>Last name <span class="req">*</span></label>
                <input type="text" class="input-form" [class.ec-invalid]="isInvalid('last_name')"
                    [(ngModel)]="editing.last_name" [ngModelOptions]="{standalone: true}" placeholder="Last name" />
            </div>
        </div>

        <div class="field">
            <label>Email address <span class="req">*</span></label>
            <input type="email" class="input-form" [class.ec-invalid]="isInvalid('email')" [(ngModel)]="editing.email"
                [ngModelOptions]="{standalone: true}" placeholder="name@example.com" />
            <span class="hint">Approval links and digest emails will be sent here.</span>
        </div>

        <div class="field">
            <label>Approval email style</label>
            <div class="ec-seg">
                <button type="button" [class.on]="editing.timesheet_notification_settings?.email_type === 0"
                    (click)="setEmailType(0)">
                    <i class="bi bi-envelope"></i>Individual
                </button>
                <button type="button" [class.on]="editing.timesheet_notification_settings?.email_type === 1"
                    (click)="setEmailType(1)">
                    <i class="bi bi-collection"></i>Bulk digest
                </button>
            </div>
            <span class="hint">
                {{ editing.timesheet_notification_settings?.email_type === 1
                ? 'Bulk: one email per cycle covering every contractor.'
                : 'Individual: one approval email per contractor, sent on submission.' }}
            </span>
        </div>

        <div class="ec-schedule" *ngIf="editing.timesheet_notification_settings?.email_type === 1">
            <div class="field">
                <label>Frequency</label>
                <div class="select-wrap">
                    <select class="input-form" [(ngModel)]="editing.timesheet_notification_settings.frequency"
                        [ngModelOptions]="{standalone: true}">
                        <option [ngValue]="1">Weekly</option>
                        <option [ngValue]="2">Monthly</option>
                    </select>
                </div>
            </div>
            <div class="field">
                <label>Day</label>
                <div class="select-wrap">
                    <select class="input-form" [(ngModel)]="editing.timesheet_notification_settings.day"
                        [ngModelOptions]="{standalone: true}">
                        <option [ngValue]="0">Sunday</option>
                        <option [ngValue]="1">Monday</option>
                        <option [ngValue]="2">Tuesday</option>
                        <option [ngValue]="3">Wednesday</option>
                        <option [ngValue]="4">Thursday</option>
                        <option [ngValue]="5">Friday</option>
                        <option [ngValue]="6">Saturday</option>
                    </select>
                </div>
            </div>
            <div class="field">
                <label>Time</label>
                <input type="time" class="input-form" [(ngModel)]="editing.timesheet_notification_settings.time"
                    [ngModelOptions]="{standalone: true}" min="06:00" max="20:00" />
            </div>
        </div>

        <div class="ec-toggles">
            <div class="ec-toggle">
                <div class="ico"><i class="bi bi-envelope-check"></i></div>
                <div class="meta">
                    <span class="label">Send invite email</span>
                    <span class="sub">Email this contact a one-click approval link the next time we save.</span>
                </div>
                <span class="ec-switch" [class.on]="editing.send_invite" (click)="toggleSendInvite()"></span>
            </div>
            <div class="ec-toggle">
                <div class="ico"><i class="bi bi-shield-check"></i></div>
                <div class="meta">
                    <span class="label">Contact is active</span>
                    <span class="sub">Deactivate to stop sending approval emails to this contact.</span>
                </div>
                <span class="ec-switch" [class.on]="editing.active" (click)="toggleActive()"></span>
            </div>
        </div>
    </div>

    <div class="ec-foot">
        <div class="left">
            <i class="bi bi-clock-history"></i>
            <span *ngIf="editing.updated_at">Last edited <strong>{{ editing.updated_at | date:'mediumDate' }}</strong></span>
            <span *ngIf="!editing.updated_at">New contact</span>
            <button type="button" class="danger-link" (click)="removeContact()" [disabled]="saving">
                <i class="bi bi-trash"></i>Remove contact
            </button>
        </div>
        <div class="right">
            <button type="button" class="ec-btn ec-btn-secondary" (click)="cancelEdit()" [disabled]="saving">
                Cancel
            </button>
            <button type="button" class="ec-btn ec-btn-primary" (click)="saveEdit()"
                [disabled]="!formValid || saving">
                <span class="ec-spinner" *ngIf="saving"></span>
                <i class="bi bi-check-lg" *ngIf="!saving"></i>
                {{ saving ? 'Saving…' : 'Save changes' }}
            </button>
        </div>
    </div>
</ng-container>
